// extracted by mini-css-extract-plugin
export default {"faq-section":"preguntasfrecuentes_faq-section__Vq48I","link":"preguntasfrecuentes_link__0IWn9","accordion-button":"preguntasfrecuentes_accordion-button__PWeiP"};